// src/layouts/AdminLayoutTop.jsx
import React from "react";
import { Logout } from "../../components/Admin/AdminLayout";
import { Chatbot } from "../../components/Chatbot/Chatbot";
import { logoEduca } from "../../assets";
import "./AdminLayoutTop.scss"; // Puedes crear este SCSS o reutilizar AdminLayout.scss si se adapta

export function AdminLayoutTop({ children }) {
  return (
    <div className="admin-layouttop">
      
      {/* No incluimos el bloque izquierdo */}
      <div className="admin-layouttop-top">
        <div className="admin-layouttop-topheader">
          <img src={logoEduca.logoE360} alt="logoE360" className="logo" />
          <Logout />
        </div>
        <div className="admin-layout__right-topcontent">{children}</div>
      </div>
      {/* Chatbot flotante, si lo requieres */}
      <Chatbot />
    </div>
  );
}
